import type { Module } from "@webmotors/ioc";
import { LastSearchService } from "./last-search.service";
import { LoggerModule, CookieModule } from "@packages/common";

export const LastSearchModule: Module = {
  name: "LastSearchModule",
  modules: [CookieModule, LoggerModule],
  providers: [LastSearchService],
};
